import { AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import type { HTMLAttributes } from 'react';

export enum MTextBlockBasicAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MTextBlockBasicAEyebrowProps {
  eyebrowText?: string;
  variant?: AEyebrowProps['variant'];
}

export interface MTextBlockBasicASubheaderProps {
  text: string;
  size?: ASubheaderProps['size'];
  element?: ASubheaderProps['element'];
}

export interface MTextBlockBasicABodyProps {
  bodyText: string;
  size?: ABodyProps['size'];
  color?: ABodyProps['color'];
}

export interface MTextBlockBasicProps extends HTMLAttributes<HTMLDivElement> {
  alignment?: MTextBlockBasicAlignment;
  aEyebrow?: MTextBlockBasicAEyebrowProps;
  aSubheader?: MTextBlockBasicASubheaderProps;
  aBody?: MTextBlockBasicABodyProps;
}
